import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CamelCasePipe } from '../pipes/camal-case.pipe';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { FilterPipe } from '../pipes/filter.pipe';
import { LanguageSelectorComponent } from '../components/language-selector/language-selector.component';
import { ColorPickerComponent } from '../components/color-picker/color-picker.component';
import { ColorPickerDemoComponent } from '../components/color-picker/color-picker-demo.component';
import { SpotlightSearchComponent } from '../components/spotlight-search/spotlight-search.component';
import { DateRangeFilterComponent } from './date-range-filter/date-range-filter.component';

import { TranslateModule } from '@ngx-translate/core';
import { 
  NbIconModule, 
  NbDatepickerModule, 
  NbInputModule, 
  NbButtonModule, 
  NbSelectModule, 
  NbActionsModule,
  NbToastrModule,
  NbTooltipModule
} from '@nebular/theme';

@NgModule({
  declarations: [
    CamelCasePipe, 
    DateTimePickerComponent, 
    FilterPipe, 
    LanguageSelectorComponent, 
    ColorPickerComponent, 
    ColorPickerDemoComponent, 
    SpotlightSearchComponent,
    DateRangeFilterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDatepickerModule,
    NgxMatTimepickerModule.setLocale('en-IN'), // Set the locale for the time picker
    TranslateModule,
    NbIconModule,
    NbDatepickerModule,
    NbInputModule,
    NbButtonModule,
    NbSelectModule,
    NbActionsModule,
    NbToastrModule,
    NbTooltipModule
  ],
  exports: [
    CamelCasePipe,
    FilterPipe,
    DateTimePickerComponent,
    LanguageSelectorComponent,
    ColorPickerComponent,
    ColorPickerDemoComponent,
    SpotlightSearchComponent,
    DateRangeFilterComponent,
    TranslateModule
  ],
})
export class SharedModule { }
